import { render, staticRenderFns } from "./QuoteRowStateButtons.vue?vue&type=template&id=1c5381bc&scoped=true&"
import script from "./QuoteRowStateButtons.vue?vue&type=script&lang=js&"
export * from "./QuoteRowStateButtons.vue?vue&type=script&lang=js&"
import style0 from "./QuoteRowStateButtons.vue?vue&type=style&index=0&id=1c5381bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5381bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
